<template>
  <v-toolbar flat>
    <v-spacer />
    <v-btn
      icon
      color="warning"
      class="mb-2"
      @click="$emit('refresh')"
      :style="{ 'margin-right': '10px' }"
      :loading="loading"
      :disabled="loading"
    >
      <v-icon>mdi-refresh</v-icon>
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>

    <v-menu offset-y rounded="lg" transition="slide-y-transition" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="warning"
          class="mb-2"
          icon
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon light size="20">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item link @click="$emit('export')">
          <v-list-item-icon>
            <v-icon>mdi-file-excel</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Export to excel</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    loading: Boolean
  }
};
</script>
